import { FetchDataSourceChildrenResponse, FetchDataSourceResponse } from "../constants/dataSource";
import { FETCHING_DATA_SOURCE_CHILDREN_FAILED, FETCHING_DATA_SOURCE_CHILDREN_REQUEST, FETCHING_DATA_SOURCE_CHILDREN_SUCCEEDED, FETCHING_DATA_SOURCES_FAILED, FETCHING_DATA_SOURCES_REQUEST, FETCHING_DATA_SOURCES_SUCCEEDED } from "../constants/appConstants";

interface DataSource {
  loading: boolean;
  invalidated: boolean;
  loadingChildren: boolean;
  fetchedChildren: boolean;
  items: any[];
  oauth2: any,
  folder: {
    loading: boolean,
    items: any[],
    invalidated: boolean
  },
  mappings: {
    loading: boolean,
    items: any[]
  },
  mapping: {
    source: any,
    created: boolean,
    creating: boolean,
    error: any
  },
  syncProgress: any[],
  deletion: any[],
  migrationProgress: any[]
}

const initialState: DataSource = {
  loading: false,
  invalidated: true,
  loadingChildren: false,
  fetchedChildren: false,
  items: [],
  oauth2: {},
  folder: {
    loading: false,
    items: [],
    invalidated: true
  },
  mappings: {
    loading: false,
    items: []
  },
  mapping: {
    source: null,
    created: false,
    creating: false,
    error: null
  },
  syncProgress: [],
  deletion: [],
  migrationProgress: []
};

interface DataSourceActions {
  [key: string]: any;
}


export function dataSourceInspector(state: DataSource = initialState, action: DataSourceActions): DataSource {
  switch (action.type) {

    case FETCHING_DATA_SOURCES_REQUEST: {
      return {
        ...state,
        loading: true,
        invalidated: false
      }
    }

    case FETCHING_DATA_SOURCES_SUCCEEDED: {
      const data = action.payload as FetchDataSourceResponse;

      return {
        ...state,
        loading: false,
        items: data.datasources
      }
    }

    case FETCHING_DATA_SOURCES_FAILED: {
      return {
        ...state,
        loading: false,
        items: []
      }
    }

    case FETCHING_DATA_SOURCE_CHILDREN_REQUEST: {

      var source = action.payload.account;
      const parent = action.payload.parent;

      var items = state.items.map((item) => {
        if (item.id == source) {
          if(parent){
            return {
              ...item,
              children: {
              ...item.children,
              loading: true,
              items: [...item.children.items],
              [parent]: {
                loading: true,
                items: []
              }
              }
            }
          } else {
            return {
              ...item,
              children: {
                loading: true,
                items: []
              }
            }
          }
        }

        return item;
      });

      return {
        ...state,
        loadingChildren: true,
        items: items
      }
    }

    case FETCHING_DATA_SOURCE_CHILDREN_SUCCEEDED: {

      const data = action.payload as FetchDataSourceChildrenResponse;
      var source = data.account;
      const parent = data.parent;

      const children = data.children
      .filter((item: any) => item.name)
      .sort((d1: any, d2: any) => {
        var nameA = d1.name.toUpperCase(); 
        var nameB = d2.name.toUpperCase()

        if (d1.file && !d2.file) {
          return 1;
        }

        if (!d1.file && d2.file) {
          return -1;
        }


        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        return 0;
      });

      var items = state.items.map((item) => {
        if (item.id == source) {
          if(parent){
            return {
              ...item,
              children: {
              ...item.children,
              loading: false,
              items: [...item.children.items],
              [parent]: {
                loading: false,
                items: children
              }
              }
            }
          } else {
            return {
              ...item,
              fetchedChildren: true,
              children: {
                loading: false,
                items: children
              }
            }
          }
        }

        return item;
      });

      return {
        ...state,
        loadingChildren: false,
        fetchedChildren: true,
        items: items
      }
    }

    case FETCHING_DATA_SOURCE_CHILDREN_FAILED: {

      const data = action.payload;
      var source = data.account;
      var error = data.error;

      var items = state.items.map((item) => {
        if (item.id == source) {
          return {
            ...item,
            children: {
              loading: false,
              items: [],
              error: error
            }
          }
        }

        return item;
      });

      return {
        ...state,
        loadingChildren: false,
        items: items
      }
    }
    
    default:
      return state;
  }
}
